import React, { useEffect } from "react";
import "./index.scss";
import { Dialog, useMediaQuery } from "@material-ui/core";
import { Button } from "../../Button";
import { ReactSVG } from "react-svg";
import google from "../../../images/google_play_button.svg";
import apple from "../../../images/app_store_button.svg";
import googleQR from "../../../images/android_qrcode.svg";
import appleQR from "../../../images/apple_qrcode.svg";
import { strings } from "../../../strings/strings";

export const NoSmartDriveDialog = ({ open, alreadyInstallListener, onCancel }) => {
    const isTabletOrMobile = useMediaQuery('(max-width: 1023px)');

    useEffect(() => {
        if (open) {
            let event = 'osago_emtpl_smart_pop_up';
            console.log('Google Analytics Event = ' + event);
            // @ts-ignore
            window.dataLayer.push({ 'event': event });
        }
    }, [open]);

    return (
        <Dialog open={open} disableBackdropClick={true}>
            <div className={"dialog no-smart-drive-dialog"}>
                <div className={"dialog__content"}>
                    <span className={"dialog__title"}>{strings.noSmartDriveDialog.title}</span>

                    <p className={"dialog__message"}>{strings.noSmartDriveDialog.message}</p>

                    <div className={"no-smart-drive-dialog__store-buttons"}>
                        {
                            isTabletOrMobile ?
                                <a href={strings.refs.smart_drive_apple} target="_blank"
                                    rel="noopener noreferrer">
                                    <ReactSVG src={apple} />
                                </a>
                                :
                                <div className="no-smart-drive-dialog__qr">
                                    IOS
                                    <img src={appleQR} alt='apple qr code' />
                                </div>
                        }
                        {
                            isTabletOrMobile ?
                                <a href={strings.refs.smart_drive_android}
                                    target="_blank" rel="noopener noreferrer">
                                    <ReactSVG src={google} />
                                </a>
                                :
                                <div className="no-smart-drive-dialog__qr">
                                    Android
                                    <img src={googleQR} alt='android qr code' />
                                </div>
                        }
                    </div>

                    <Button id={'noSmartDriveDialog-btnInstalled'} label={strings.noSmartDriveDialog.btnInstalled} onClickListener={alreadyInstallListener} />

                    <Button id={'noSmartDriveDialog-btnWithout'} label={strings.noSmartDriveDialog.btnWithout} variant={"link"} onClickListener={onCancel} />

                    <p className={"dialog__description"}>{strings.noSmartDriveDialog.describtion}</p>
                </div>
            </div>
        </Dialog>
    )
}
